/* eslint-disable import/order */
/* eslint-disable import/extensions */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/global'
import Transiction from '../../components/Transition'
import { post } from '../LaundryClientBillingsActions'
import Form from './Form'

const Transition = React.forwardRef((props, ref) => {
  return <Transiction propis={props} refi={ref} />
})

function NewClient(props) {
  const { classes } = props
  const dispatch = useDispatch()

  const onSubmit = values => {
    dispatch(post(values)).then(data => {
      if (data && data.code === 200) {
        props.history.push('/laundry-client-billings')
      }
    })
  }

  const onClose = () => {
    props.history.push('/laundry-client-billings')
  }

  return (
    <Dialog open maxWidth="xl" fullScreen onClose={onClose} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" className={classes.flex}>
            Novo Cliente
          </Typography>
          <IconButton color="inherit" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Form classes={classes} onClose={onClose} onSubmit={onSubmit} />
    </Dialog>
  )
}

export default withStyles(styles)(NewClient)
